import API from 'services/api';

export const getInvoiceOptions = ({
  id,
}: {
  id: string;
}): Promise<{ code: string; name: string }[]> =>
  API.get(`/api/accommodation/calculations/${id}/invoice-options`)?.then(
    response => response?.data,
  );
